import { createContext, useContext } from "react";
import { OperationalHeatmapTypes } from "../utils/constants";
import { BootstrapContext } from "./BootstrapContext";

export const CustomerFeatureFlagsContext = createContext({
  detectionsActive: false,
  autoRemediationActive: false,
  showNightlyFlow: false,
  heatmapDisplayMode: OperationalHeatmapTypes.ATTACK_PATH_BASED,
  heatmapOpacityDisabled: false,
  aiPostureDashboardEnabled: false,
  aiPostureMcpEnabled: false,
});

export const CustomerFeatureFlagsProvider = ({ children }) => {
  const { customerFeatureFlagsProcessed } = useContext(BootstrapContext);

  return (
    <CustomerFeatureFlagsContext.Provider
      value={{
        detectionsActive:
          customerFeatureFlagsProcessed.detectionsActive || false,
        autoRemediationActive:
          customerFeatureFlagsProcessed.autoRemediationActive || false,
        showNightlyFlow: customerFeatureFlagsProcessed.showNightlyFlow || false,
        heatmapDisplayMode:
          customerFeatureFlagsProcessed.heatmapDisplayMode ||
          OperationalHeatmapTypes.ATTACK_PATH_BASED,
        heatmapOpacityDisabled:
          customerFeatureFlagsProcessed.heatmapOpacityDisabled || false,
        aiPostureDashboardEnabled:
          customerFeatureFlagsProcessed.aiPostureDashboardEnabled || false,
        aiPostureMcpEnabled:
          customerFeatureFlagsProcessed.aiPostureMcpEnabled || false,
      }}
    >
      {children}
    </CustomerFeatureFlagsContext.Provider>
  );
};
